import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/elctdoc/box`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/boxs`,
};

export const URLS = {
    ptli0703001q: `${BASE.path}/ptli0703001q`, // list
    ptli0703002s: `${BASE.path}/ptli0703002s`, // modification
    ptli0703003s: `${BASE.path}/ptli0703003s`, // regist
};

export const APIS = {
    // Insert document box !== 문서함 등록 ==!
    insertElctDocBox: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update document box !== 문서함 수정 ==!
    updateElctDocBox: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete document box !== 문서함 삭제 ==!
    deleteElctDocBox: (intfId: any) => {
        return api.delete(`${BASE.api}/${intfId}`);
    },
    // Get a list of document box. !== 문서함 목록을 조회한다.==!
    getElctDocBoxList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get document box details. !== 문서함 상세정보 조회 ==!
    getElctDocBox: (intfId: any) => {
        return api.get(`${BASE.api}/${intfId}`);
    },
};

export const SF_DOC_BOX_MGMT_SRCH: TFormSchema = {
    id: "form_docBoxMgmtSrch",
    schema: {
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_INTF_ID", value: "E" },
                { label: "L_INTF_NM", value: "A" },
                { label: "L_SNDR_NM", value: "B" },
                { label: "L_RECPT_NM", value: "C" },
                { label: "L_API_URL_ADDR", value: "D" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
        },
        inexTpCd: {
            type: "select",
            label: "L_INEX_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "CGM0176",
        },
        actvtYn: {
            type: "select",
            label: "L_ACTVT_YN",
            all: true,
            area: "comnCd",
            comnCd: "COM0064",
            // defaultValue: "Y"
        },
        sndrcvTpCd:{
            type: "select",
            label: "L_SNDRCV_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0070",
        },
        sndrcvDvnCd:{
            type:"select",
            label: "L_SNDRCV_DVN_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0077",
        },
    },
};

export const SG_DOC_BOX_MGMT_LIST: TGridSchema = {
    id: "grid_docBoxMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "10%" }] },
        { cells: [{ header: "L_INTF_NM", binding: "intfNm", width: "15%" }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "10%" }] },
        { cells: [{ header: "L_RECPT", binding: "rcvrNm", width: "10%" }] },
        { cells: [{ header: "L_API_URL_ADDR", binding: "apiUrlAddr", width: "*" }] },
        { cells: [{ header: "L_INEX_TP_NM", binding: "inexTpCdNm", width: "10%" }] },
        { cells: [{ header: "L_SNDRCV_DVN_NM", binding: "sndrcvDvnCdNm", width: "10%" }] },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "10%" }] },
        { cells: [{ header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCdNm", width: "15%" }] },
        { cells: [{ header: "L_ACTVT_YN", binding: "actvtYnNm", width: "5%" }] },
    ],
    body: [
        { cells: [{ binding: "intfId" }] },
        { cells: [{ binding: "intfNm", align: "left" }] },
        { cells: [{ binding: "sndrNm", align: "left" }] },
        { cells: [{ binding: "rcvrNm", align: "left" }] },
        { cells: [{ binding: "apiUrlAddr", align: "left" }] },
        { cells: [{ binding: "inexTpCdNm" }] },
        { cells: [{ binding: "sndrcvDvnCdNm" }] },
        { cells: [{ binding: "bsopClsfCdNm" }] },
        { cells: [{ binding: "sndrcvTpCdNm" }] },
        { cells: [{ binding: "actvtYnNm" }] },
    ],
};

export const SF_DOC_BOX_MGMT_INFO: TFormSchema = {
    id: "form_docBoxMgmtInfo",
    schema: {
        intfId: { type: "text", label: "L_INTF_ID", required: true, placeholder: "IF-I-COM-001", maxLength: 12 },
        intfNm: { type: "text", label: "L_INTF_NM", required: true },
        sndrNm: { type: "text", label: "L_SNDR_NM", required: true, maxLength: 100 },
        rcvrNm: { type: "text", label: "L_RECPT", required: true, maxLength: 100 },
        sendSysmNm: { type: "text", label: "L_SEND_SYSM_NM", required: true, maxLength: 100 },
        rcpnSysmNm: { type: "text", label: "L_RCPN_SYSM", required: true, maxLength: 100 },
        apiUrlAddr: { type: "text", label: "L_API_URL_ADDR" },
        //rspnTmout: { type: "number", label: "L_RSPN_TMOUT", max: 999_9999 },
        inpInfoCn: { type: "textarea", label: "L_INP_INFO_CN" },
        otptInfoCn: { type: "textarea", label: "L_OTPT_INFO_CN" },
        inexTpCd: { type: "select", label: "L_INEX_TP_NM", area: "comnCd", comnCd: "CGM0176", required: true },
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_NM", area: "comnCd", comnCd: "COM0024", required: true },
        sndrcvTpCd: { type: "select", label: "L_SNDRCV_TP_NM", area: "comnCd", comnCd: "COM0070" },
        lnkgPrtclCd: { type: "select", label: "L_LNKG_PRTCL", area: "comnCd", comnCd: "COM0071" },
        lnkgDtaTpCd: { type: "select", label: "L_LNKG_DTA_TP", area: "comnCd", comnCd: "COM0072" },
        prcssMetdCd: { type: "select", label: "L_PRCSS_METD", area: "comnCd", comnCd: "COM0073" },
        lnkgCycleCd: { type: "select", label: "L_LNKG_CYCLE", area: "comnCd", comnCd: "COM0074" },
        actvtYn: { type: "radio", label: "L_ACTVT_YN", area: "comnCd", comnCd: "COM0064", defaultValue: "Y" },
        msgBodyLogYn: {
            type: "radio",
            label: "L_MSG_BODY_LOG_YN",
            area: "comnCd",
            comnCd: "COM0064",
            defaultValue: "Y",
        },
        trscLogYn: { type: "radio", label: "L_TRSC_LOG_YN", area: "comnCd", comnCd: "COM0064", defaultValue: "Y" },
        sndrcvDvnCd: {
            type: "radio",
            label: "L_SNDRCV_DVN_NM",
            area: "comnCd",
            comnCd: "COM0077",
            required: true,
        },
    },
};

export const SG_DOC_TRGT_INFO_LIST: TGridSchema = {
    id: "grid_docTrgtList",
    options: { edit: false, index: true },
    head: [
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*" }] },
        { cells: [{ header: "L_TRSC_ID", binding: "trscId", width: "*" }] },
        { cells: [{ header: "L_SNDR_ID", binding: "intfSndrId", width: "*" }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "*" }] },
        { cells: [{ header: "L_RCVR_ID", binding: "intfRcvrId", width: "*" }] },
        { cells: [{ header: "L_RCVR_NM", binding: "rcvrNm", width: "*" }] },
    ],
    body: [
        {cells: [{binding: "intfId",type: "text"}]},
        {cells: [{binding: "trscId",type: "text"}]},
        {cells: [{binding: "intfSndrId",type: "text"}]},
        {cells: [{binding: "sndrNm",type: "text"}]},
        {cells: [{binding: "intfRcvrId",type: "text"}]},
        {cells: [{binding: "rcvrNm",type: "text"}]},
    ],
};
